import { useInfiniteQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { Task } from 'utils/types';

import c from '../utils/constants';
import { taskTransformer } from '../transformer';

export default function useGetTasks(params = {}) {
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  return useInfiniteQuery<{
    data: Task[];
    nextPage: number;
    previousPage: number;
  }>({
    queryKey: [c.TASKS, params],
    getNextPageParam: (prevData) => prevData.nextPage,
    getPreviousPageParam: (prevData) => prevData.previousPage,
    queryFn: async ({ pageParam = 1 }) => {
      const api = new Api(args);

      const data = await api.get(
        await withAcl({
          account: {
            url: '/api/v1/tasks',
            params: {
              page: pageParam,
              ...params,
              include: ['lead', 'accountUsers'],
            },
            transformer: taskTransformer.tasks,
          },
          admin: {
            url: `/api/v2/accounts/${accountId}/users/${accountUserId}/tasks`,
            params: {
              page: pageParam,
              ...params,
              include: ['lead', 'accountUsers'],
            },
            transformer: taskTransformer.tasks,
          },
        }),
      );

      return data;
    },
  });
}
